import { IQuantivePlusExistingKr } from "../models";
import { MetricPropsRequiredForPiExistingMetricMap } from "../models/pi-kr.models";

export function mapMetricsToPiExistingKrs(metrics: MetricPropsRequiredForPiExistingMetricMap[]): IQuantivePlusExistingKr[] {
  return metrics.map((metric) => metricToPiExistingKr(metric));
}

function metricToPiExistingKr(metric: MetricPropsRequiredForPiExistingMetricMap): IQuantivePlusExistingKr {
  return {
    title: metric.name,
    ...(metric.description && {
      description: metric.description,
    }),
  };
}
